import { Link } from 'react-router-dom'
import AppLayout from './AppLayout'
import './obs/obs.css'
import { usePageMeta } from './hooks/usePageMeta'
import { NOM_PRODUIT } from './constants'

export default function NotFoundPage() {
  // Caddy sert le shell SPA en HTTP 200 sur toute route inconnue (fallback voulu), donc une URL
  // inexistante était un « soft-404 » : statut 200 ET indexable, ce qui laisse Google avaler un
  // espace d'URL infini. Corriger le STATUT demanderait une liste blanche de routes côté Caddy —
  // fragile. Le noindex ferme la moitié SEO du problème sans toucher à l'infra (audit 26/07).
  usePageMeta({
    title: `Page introuvable — ${NOM_PRODUIT}`,
    noindex: true,
  })
  return (
    <AppLayout>
      <div className="obs2-jetons text-(--c-text) flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
        <span className="text-7xl font-extrabold text-(--c-brand) mb-4">404</span>
        <h1 className="obs2-h1">
          Page introuvable
        </h1>
        <p className="text-lg text-(--c-muted) mb-8 max-w-md">
          La page que vous recherchez n&apos;existe pas ou a &eacute;t&eacute; d&eacute;plac&eacute;e.
        </p>
        <Link
          to="/"
          className="obs2-btn obs2-btn-primary"
        >
          {"Retour à l'accueil"}
        </Link>
      </div>
    </AppLayout>
  )
}
